import img1 from '../../assets/dealsImg/1.png'
import img2 from '../../assets/dealsImg/2.png'
import img3 from '../../assets/dealsImg/3.png'
import img4 from '../../assets/dealsImg/4.png'
import img5 from '../../assets/dealsImg/5.png'
import img6 from '../../assets/dealsImg/6.png'
import img7 from '../../assets/dealsImg/7.png'
import img8 from '../../assets/dealsImg/8.png'

const dealsData = [
    {
      image: img1,
      title: "Date Night Special",
      points: 20,
      tagline: "The perfect pairing for a memorable night!",
      description:
        "Enjoy a delightful meal at Almost Home and then head over to Marvin’s for a sweet treat—10% off at both locations when you shop with us! Whether you’re savoring a delicious dinner or indulging in something sweet, the night is yours to make extra special.",
      discounts: [
        "Get 10% off at Marvin’s",
        "Get 10% off at Almost Home",
      ],
      locations: ["Almost Home", "Marvin’s"],
    },
    {
      image: img2,
      title: "Boutique Duo",
      points: 15,
      tagline: "Look fabulous from head to toe!",
      description:
        "Treat yourself to a stylish outfit at Britt’s Blooming Boutique, then find the perfect pair of shoes at Shoe Sensation—and enjoy $5 off at one and 10% off at the other! Get that complete look for less while supporting local shops. It’s a win-win!",
      discounts: [
        "Get $5 off at Shoe Sensation",
        "Get 10% off at Britt’s Blooming Boutique",
      ],
      locations: ["Shoe Sensation", "Britt’s Blooming Boutique"],
    },
    {
      image: img4,
      title: "Taco 'n' Tunes",
      points: 20,
      tagline: "Flavor + vibes = the ultimate combo",
      description:
        "Kick off your night with bold flavors at Taco Wapo, then head to Lost Hollow Beer Co. where the music and the brews are flowing. Grab your crew, this one’s made for good times.",
      discounts: [
        "Get 10% off your meal at Taco Wapo",
        "Get $2 off your first drink at Lost Hollow Beer Co",
      ],
      locations: ["Taco Wapo", "Lost Hollow"],
    },
    {
      image: img3,
      title: "Flower & Fashion",
      points: 15,
      tagline: "Refresh your look and your space!",
      description:
        "Buy stunning flowers at Silver Bell Flowers, then add a pop of style with a chic find at Blushing Beaus Boutique—$7 off at one and 5% off at the other! Perfect for a burst of color in your wardrobe and your home.",
      discounts: [
        "Get $7 off at Blushing Beaus Boutique",
        "Get 5% off at Silver Bell Flowers",
      ],
      locations: ["Blushing Beaus Boutique", "Silver Bell Flowers"],
    },
    {
      image: img5,
      title: "Foodie Combo",
      points: 20,
      tagline: "Satisfy your cravings with the ultimate food crawl!",
      description:
        "Start with delicious tacos at Taco Wapo, then enjoy a hearty meal at Marvin’s—$5 off at one and 10% off at the other! A perfect combo for those who love great food and even greater deals. Grab your food and enjoy the savings!",
      discounts: [
        "Get $5 off at Marvin’s",
        "Get 10% off at Taco Wapo",
      ],
      locations: ["Taco Wapo", "Marvin’s"],
    },
    {
      image: img6,
      title: "Vintage Lovers",
      points: 15,
      tagline: "Embrace the charm of the past and present!",
      description:
        "Explore hidden gems at Antiques & Collectibles and discover unique pieces at Conspire Contemporary Craft with 10% off at Conspire and 15% off at Antiques & Collectibles. Whether you’re into vintage treasures or handmade crafts, this combo lets you indulge in timeless finds and modern flair.",
      discounts: [
        "Get 10% off at Conspire Contemporary Craft",
        "Get 15% off at Antiques & Collectibles",
      ],
      locations: ["Conspire Contemporary Craft", "Antiques & Collectibles"],
    },
    {
      image: img7,
      title: "Brunch & Boots",
      points: 25,
      tagline: "Boots and brunch—what could be better?",
      description:
        "Enjoy a hearty brunch at Fluttering Duck with 15% off, then step out in style with 10% off at Burdge Boots & Boutique. Not only will you fill your belly, but you’ll also get an amazing deal on your next pair of boots. A cozy combo to kickstart your day!",
      discounts: [
        "Get 10% off at Burdge Boots & Boutique",
        "Get 15% off at The Fluttering Duck",
      ],
      locations: ["The Fluttering Duck", "Burdge Boots & Boutique"],
    },
    {
      image: img8,
      title: "Craft & Snack",
      points: 15,
      tagline: "Get creative, then trea't yourself!",
      description:
        "Spend the afternoon browsing unique handmade goods at Conspire Contemporary Craft, then swing by The Bodega for a cozy little snack break. A perfect lowkey solo date or artsy hangout with a friend!",
      discounts: [
        "Get 15% off any item at Conspire Contemporary Craft",
        "Get a free cookie with any drink at The Bodega",
      ],
      locations: ["Conspire Contemporary Craft", "The Bodega"],
    },    
  ];
  
  export default dealsData;
  